/* TalkingThyme - theme interactions */
(function () {
  'use strict';
  document.documentElement.classList.add('js');
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) => {
    try { return (window.Shopify && Shopify.currency)
      ? `$${(cents / 100).toFixed(2)}`
      : `$${(cents / 100).toFixed(2)}`; }
    catch (e) { return `$${(cents / 100).toFixed(2)}`; }
  };

  /* Sticky header shadow */
  const header = $('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-stuck', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Drawers (mobile nav + cart) */
  function bindDrawer(drawer) {
    if (!drawer) return;
    let trigger = null;
    const open  = (source) => {
      trigger = source || null;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      const closeButton = $('[data-drawer-close]', drawer);
      if (closeButton) closeButton.focus();
    };
    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (trigger) { trigger.setAttribute('aria-expanded', 'false'); trigger.focus(); }
      document.body.style.overflow = '';
    };
    drawer._open = open; drawer._close = close;
    $$('[data-drawer-close]', drawer).forEach(b => b.addEventListener('click', close));
    const ov = $('.drawer__overlay', drawer);
    if (ov) ov.addEventListener('click', close);
  }
  const navDrawer  = $('#nav-drawer');
  const cartDrawer = $('#cart-drawer');
  bindDrawer(navDrawer);
  bindDrawer(cartDrawer);
  $$('[data-open="nav"]').forEach(b => b.addEventListener('click', (e) => navDrawer && navDrawer._open(e.currentTarget)));
  $$('[data-open="cart"]').forEach(b => b.addEventListener('click', (e) => {
    if (cartDrawer) { e.preventDefault(); cartDrawer._open(e.currentTarget); refreshCart(); }
  }));
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { navDrawer && navDrawer._close(); cartDrawer && cartDrawer._close(); }
  });

  /* Accordions */
  $$('.accordion__head').forEach(head => {
    head.setAttribute('aria-expanded', head.closest('.accordion__item').classList.contains('is-open') ? 'true' : 'false');
    head.addEventListener('click', () => {
      const item = head.closest('.accordion__item');
      const isOpen = item.classList.toggle('is-open');
      head.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  /* Quantity steppers */
  $$('.qty').forEach(box => {
    const input = $('input', box);
    $$('[data-step]', box).forEach(btn => btn.addEventListener('click', () => {
      const v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.step, 10));
      input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  });

  /* PDP gallery */
  const mainImg = $('#pdp-main-img');
  if (mainImg) {
    $$('.pdp__thumbs button').forEach(btn => btn.addEventListener('click', () => {
      mainImg.src = btn.dataset.full;
      $$('.pdp__thumbs button').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    }));
  }

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    $$('.reveal').forEach(el => io.observe(el));
  } else {
    $$('.reveal').forEach(el => el.classList.add('is-in'));
  }

  /* ---- Cart (AJAX) ---- */
  const cartCountEls = () => $$('.cart-count');
  function setCount(n) {
    cartCountEls().forEach(el => { el.textContent = n; el.style.display = n > 0 ? '' : 'none'; });
  }
  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      setCount(cart.item_count);
      renderCartDrawer(cart);
    } catch (e) {}
  }
  function renderCartDrawer(cart) {
    const body = $('#cart-drawer-body');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="center" style="padding:3rem 0;color:var(--text-soft)">Your cart is empty.</p>';
      const f = $('#cart-drawer-foot'); if (f) f.style.display = 'none';
      return;
    }
    body.innerHTML = cart.items.map(it => `
      <div class="cart-line" data-key="${it.key}">
        <a href="${it.url}"><img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i,'_160x$1') : ''}" alt=""></a>
        <div>
          <a href="${it.url}" style="font-family:var(--font-heading);font-size:1.05rem">${it.product_title}</a>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<div style="font-size:.82rem;color:var(--ink-faint)">${it.variant_title}</div>` : ''}
          <div class="qty" style="margin-top:.5rem;transform:scale(.85);transform-origin:left">
            <button data-cart-step="-1" data-key="${it.key}">−</button>
            <input value="${it.quantity}" readonly>
            <button data-cart-step="1" data-key="${it.key}">+</button>
          </div>
        </div>
        <div style="text-align:right">
          <div class="price">${money(it.final_line_price)}</div>
          <button data-cart-remove="${it.key}" style="background:none;border:0;color:var(--ink-faint);font-size:.75rem;text-decoration:underline;margin-top:.4rem">Remove</button>
        </div>
      </div>`).join('');
    const foot = $('#cart-drawer-foot');
    if (foot) { foot.style.display = ''; $('#cart-drawer-total').textContent = money(cart.total_price); }
    bindCartControls();
  }
  function bindCartControls() {
    $$('[data-cart-step]').forEach(b => b.addEventListener('click', () => {
      const line = b.closest('.cart-line');
      const cur = parseInt($('input', line).value, 10);
      changeLine(b.dataset.key, Math.max(0, cur + parseInt(b.dataset.cartStep, 10)));
    }));
    $$('[data-cart-remove]').forEach(b => b.addEventListener('click', () => changeLine(b.dataset.cartRemove, 0)));
  }
  async function changeLine(key, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    const cart = await res.json();
    setCount(cart.item_count); renderCartDrawer(cart);
  }

  /* Add to cart forms */
  $$('form[data-product-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const engInput = $('[data-engraving-input]', form);
      if (engInput && engInput.required && !engInput.disabled && !engInput.value.trim()) {
        engInput.focus();
        engInput.setCustomValidity('Please enter the text to engrave.');
        engInput.reportValidity();
        engInput.addEventListener('input', () => engInput.setCustomValidity(''), { once: true });
        return;
      }
      const btn = $('[type=submit]', form);
      const label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      try {
        const fd = new FormData(form);
        const addon = $('[data-engraving-addon]', form);
        const engraving = (fd.get('properties[Engraving]') || '').toString().trim();
        let res;
        if (addon && engraving) {
          // Paid engraving: add the board and the engraving add-on product together.
          const qty = parseInt(fd.get('quantity'), 10) || 1;
          const props = {};
          for (const [k, v] of fd.entries()) {
            const m = k.match(/^properties\[(.+)\]$/);
            if (m && v.toString().trim()) props[m[1]] = v.toString().trim();
          }
          res = await fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [
              { id: Number(fd.get('id')), quantity: qty, properties: props },
              { id: Number(addon.value), quantity: qty, properties: { 'For': addon.dataset.for, 'Engraving': engraving } }
            ] })
          });
        } else {
          if (!engraving) fd.delete('properties[Engraving]');
          res = await fetch('/cart/add.js', { method: 'POST', body: fd });
        }
        if (!res.ok) throw new Error('add failed');
        btn.textContent = 'Added ✓';
        await refreshCart();
        if (cartDrawer) cartDrawer._open();
      } catch (err) {
        window.location = '/cart';
      } finally {
        setTimeout(() => { btn.disabled = false; btn.textContent = label; }, 1200);
      }
    });
  });

  refreshCart();
})();
